
<div class="webhook-debug-log">
      
   <div [hidden]="hidelogFace" class="log-face">
    <div class="tool-bar">
      
      <div class="tool-bar-button">
        <button nz-button nzType="primary"  nzShape="circle" (click)="hidelogFace=true">
          <nz-icon nzType="arrow-left" nzTheme="outline" />
        </button>
        <button nz-button nzType="primary" nzShape="circle" (click)="refreshDataLog()" [nzLoading]="loadingDataLog">
          <nz-icon nzType="sync" nzTheme="outline" />
        </button>
        <mat-divider [vertical]="true"></mat-divider>
        <nz-tag nzColor="blue">ID: {{ selected?.IDJOB }}</nz-tag>
        <nz-tag nzColor="blue">{{'version'|translateTA}}: {{ selected?.SEQUENCE }}</nz-tag>
        <nz-tag nzColor="green">{{ selected?.STATUS_DESC|translateTA }}</nz-tag>
        <nz-tag nzColor="yellow">{{ selected?.TYPEEXEC }}</nz-tag>
        <nz-tag nzColor="purple">{{ selected?.DHINI }} → {{ selected?.DHEND }}</nz-tag>
      </div>
      <button nz-button nzType="default" (click)="jsonMode=!jsonMode">
       <nz-icon nzType="code" nzTheme="outline" *ngIf="jsonMode"/>
       <nz-icon nzType="fund-view" nzTheme="outline" *ngIf="!jsonMode"/>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div class="webhook-debug-log">
      <nz-spin [nzSpinning]="loadingDataLog" class="full-spin ">
        <div class="loading-container">
          <json-viewer [json]="formatJSON(selected?.DATALOG)" *ngIf="jsonMode"></json-viewer>
          <webhook-log-detail  *ngIf="selected?.DATALOG!=null && !jsonMode" [data]="formatJSON(selected?.DATALOG)"></webhook-log-detail>
        </div>
      </nz-spin>
    </div>
   
   </div>

  <div [hidden]="!hidelogFace">
    <nz-float-button nzType="primary" [nzIcon]="reload" (nzOnClick)="refreshData()" ></nz-float-button>
    
    <ng-template #reload>
          <nz-icon nzType="reload" ></nz-icon>
      </ng-template>
        
  
      <nz-table #logTable 
                  [nzData]="logs" 
                  [nzBordered]="true"   
                  [nzScroll]="{ y: '50vh' }" 
                  nzSize="default" 
                  nzShowSizeChanger
                  [nzFrontPagination]="false"
                  [nzLoading]="loading"
                  [nzTotal]="total"
                  [nzPageSize]="pageSize"
                  [nzPageIndex]="pageIndex"
                  [nzTableLayout]="'fixed'"
                  (nzQueryParams)="onQueryParamsChange($event)"
                  class="variable-table">
              <thead>

                  <tr>
                      <th  colspan="2" class="cell-normal" nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="IDJOB">{{'workflow.log.idjob'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.IDJOB"  [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menuidjob">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                      <th  class="cell-normal" nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="SEQUENCE">{{'workflow.log.sequence'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.SEQUENCE"  [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menusequence">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                      <th  colspan="2" class="cell-normal" nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="CODECOMPANY">{{'workflow.log.codecompany'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.CODECOMPANY"   [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menucodecompany">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                      <th  class="cell-normal" nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="TYPEEXEC" >{{'workflow.log.typeexec'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.TYPEEXEC"   [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menutypeexec">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                      
                      <th  class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="STATUS">{{'workflow.log.status'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.STATUS" [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menustatus">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                      <th  class="cell-normal" nzCustomFilter  nzColumnKey="MESSAGE">{{'workflow.log.message'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.MESSAGE" [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menumessage">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                      <th  class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="DHINI">{{'workflow.log.dhini'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.DHINI"  [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menudhini">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                      <th class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="DHEND">{{'workflow.log.dhend'|translateTA}}
                          <nz-filter-trigger [(nzVisible)]="visible.DHEND"  [nzActive]="logTable.data.length > 0" [nzDropdownMenu]="menudhend">
                              <nz-icon nzType="search" />
                          </nz-filter-trigger>
                      </th>
                  </tr>
              </thead>
              <tbody>
              @for (v of logTable.data; track v.IDJOB) {
                  <tr (dblclick)="editVariableDoubleClick(v)">
                      <!--td [nzExpand]="expandSet.has(v.IDJOB)" (nzExpandChange)="onExpandChange(v.IDJOB, $event,v)"></td-->
                      <td  nz-tooltip [nzTooltipTitle]="v.IDJOB"  class="cell-normal" colspan="2">{{ v.IDJOB }}</td>
                      <td  class="cell-normal">{{ v.SEQUENCE }}</td>
                      <td  nz-tooltip [nzTooltipTitle]="v.CODECOMPANY + '-' + v.CONTEXTO_NAME"  class="cell-normal" colspan="2">{{ v.CODECOMPANY }} - {{v.CONTEXTO_NAME}}</td>
                      <td   class="cell-normal">{{ v.TYPEEXEC }}</td>
                      <td   class="cell-normal">{{ v.STATUS_DESC|translateTA }}</td>
                      <td  nz-tooltip [nzTooltipTitle]="v.MESSAGE"  class="cell-normal">{{ v.MESSAGE }}</td>
                      <td  nz-tooltip [nzTooltipTitle]="v.DHINI" class="cell-normal">{{ v.DHINI }}</td>
                      <td   nz-tooltip [nzTooltipTitle]="v.DHEND" class="cell-normal">{{ v.DHEND }}</td>
                  </tr>
                  <!--tr [nzExpand]="expandSet.has(v.IDJOB)" >
                      {{v.MESSAGE}}
                      <mat-divider></mat-divider>
                      <nz-spin [nzSpinning]="loadingDataLog">
                          <json-viewer [json]="formatJSON(v.DATALOG)" ></json-viewer>
                          <webhook-log-detail  *ngIf="v.DATALOG!=null" [data]="formatJSON(v.DATALOG)"></webhook-log-detail>
                      </nz-spin>
                      
                  </tr-->
                }
              </tbody>
          </nz-table>

          <nz-dropdown-menu #menuidjob="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-input [mainformGroup]="filterGroup"  [field]="IDJOBFIELD" ></webhook-form-input>
                <button nz-button nzSize="small" nzType="primary" (click)="search('IDJOB')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('IDJOB')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>


          <nz-dropdown-menu #menumessage="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-input [mainformGroup]="filterGroup"  [field]="MESSAGEFIELD" ></webhook-form-input>
                <button nz-button nzSize="small" nzType="primary" (click)="search('MESSAGE')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('MESSAGE')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>


          <nz-dropdown-menu #menusequence="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-input [mainformGroup]="filterGroup"  [field]="SEQUENCEFIELD" ></webhook-form-input>
                <button nz-button nzSize="small" nzType="primary" (click)="search('SEQUENCE')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('IDJOB')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>

          <nz-dropdown-menu #menucodecompany="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-search [mainformGroup]="filterGroup"  [field]="CODECOMPANYFIELD" ></webhook-form-search>
                <button nz-button nzSize="small" nzType="primary" (click)="search('CODECOMPANY')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('CODECOMPANY')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>

          <nz-dropdown-menu #menustatus="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-select [mainformGroup]="filterGroup"  [field]="STATUSFIELD" ></webhook-form-select>
                <button nz-button nzSize="small" nzType="primary" (click)="search('STATUS')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('STATUS')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>

          <nz-dropdown-menu #menutypeexec="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-select [mainformGroup]="filterGroup"  [field]="TYPEEXECFIELD" ></webhook-form-select>
                <button nz-button nzSize="small" nzType="primary" (click)="search('TYPEEXEC')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('TYPEEXEC')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>


          <nz-dropdown-menu #menudhini="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-date [mainformGroup]="filterGroup"  [field]="DHINIFIELD" ></webhook-form-date>
                <button nz-button nzSize="small" nzType="primary" (click)="search('DHINI')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('DHINI')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>

          <nz-dropdown-menu #menudhend="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
                <webhook-form-date [mainformGroup]="filterGroup"  [field]="DHENDFIELD" ></webhook-form-date>
                <button nz-button nzSize="small" nzType="primary" (click)="search('DHEND')" class="search-button">{{'search'|translateTA}}</button>
                <button nz-button nzSize="small" (click)="reset('DHEND')">{{'reset'|translateTA}}</button>
              </div>
            </div>
          </nz-dropdown-menu>
    </div>
</div>